import { yupResolver } from "@hookform/resolvers/yup";
import { useContext } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import * as yup from "yup";

import MyCheckboxCircle from "../../components/inputs/MyCheckboxCircle";
import MyTextField from "../../components/inputs/MyTextField";
import MyButton from "../../components/MyButton";
import { AuthContext } from "../../context/AuthProvider";
import { SiteContext } from "../../context/SiteProvider";
import { useAuth } from "../../hooks/useAuth";

const Login = () => {
  const { signInMutation } = useAuth();
  const { setLoadingScreen } = useContext(SiteContext);
  const { setProfile } = useContext(AuthContext);
  const navigate = useNavigate();

  const initValues = {
    remember: localStorage.getItem("isRememberId") === "true",
    userId:
      localStorage.getItem("isRememberId") === "true" &&
      localStorage.getItem("rememberId")
        ? localStorage.getItem("rememberId")
        : "",
    password: "",
  };

  const validationSchema = yup.object({
    userId: yup.string().required("필수 입력 항목입니다."),
    password: yup.string().required("필수 입력 항목입니다."),
  });
  const methods = useForm({
    defaultValues: initValues,
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = (data) => {
    const payload = {
      userKeyCode: data.userId,
      password: data.password,
    };
    setLoadingScreen(true);

    signInMutation.mutate(payload, {
      onSuccess: (res) => {
        setProfile(res.user);
        localStorage.setItem("accessToken", res.accessToken);
        localStorage.setItem("userId", res.user.userId);
        localStorage.setItem("isRememberId", false);
        localStorage.setItem("rememberId", "");
        localStorage.setItem("loginUser", JSON.stringify(res.user));
        if (data.remember) {
          localStorage.setItem("isRememberId", true);
          localStorage.setItem("rememberId", res.user.id);
          localStorage.setItem("refreshToken", res.refreshToken);
        }
        navigate("/");
      },
      onError: (err) => {
        switch (err.data.code) {
          case "NOT_ACCEPTABLE":
            if(err.data.data === "UserService > checkAuth UserType= Retired"){ // 추후 code 값을 변경하거나 해서 Retired일 경우 다르게 처리하도록 바꿔야 할 듯
              alert(
                "이미 탈퇴한 회원입니다."
              );
            }else{
              alert(
                "가입 후 관리자 승인이 필요합니다. 관리자에게 문의하여주세요."
              );
            }
            break;
          default:
            alert("아이디 또는 비밀번호가 일치하지 않습니다.");
            break;
        }
      },
      onSettled: () => {
        setLoadingScreen(false);
      },
    });
  };

  return (
    <div
      className="flex items-center bg-cover bg-right-top bg-no-repeat login-page lg:pt-[100px] md:pb-10 py-6"
      style={{
        backgroundImage: "url(/assets/img/logbg.png)",
        minHeight: "calc(100vh - 184px)",
      }}
    >
      <div className="container flex justify-center">
        <div className="max-w-[470px] w-full">
          <h2 className="lg:mb-14 md:mb-10 sm:mb-6 mb-4 font-bold lg:text-4xl sm:text-3xl text-xl text-center">
            로그인
          </h2>

          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)}>
              <div className="flex flex-wrap md:mb-5 mb-3">
                <label
                  htmlFor="userId"
                  className="md:mt-4 md:w-[100px] w-full font-semibold"
                >
                  아이디
                </label>
                <div className="flex-1">
                  <MyTextField
                    id="userId"
                    name="userId"
                    placeholder="아이디를 입력하세요."
                  />
                </div>
              </div>

              <div className="flex flex-wrap md:mb-5 mb-3">
                <label
                  htmlFor="password"
                  className="md:mt-4 md:w-[100px] w-full font-semibold"
                >
                  비밀번호
                </label>
                <div className="flex-1">
                  <MyTextField
                    id="password"
                    type="password"
                    name="password"
                    placeholder="비밀번호를 입력하세요."
                  />
                </div>
              </div>

              <MyCheckboxCircle name="remember" label="아이디 기억하기" />

              <div className="md:mt-5 mt-3">
                <MyButton
                  variant="contained"
                  color="primary"
                  className="w-full font-semibold h-[56px]"
                  type="submit"
                  size="small"
                >
                  로그인
                </MyButton>
              </div>

              <ul className="mt-2 flex items-center justify-center gap-2 text-[#999999]">
                <li>
                  <Link to="/FindId">아이디 찾기</Link>
                </li>
                <li className="w-[1px] h-2 bg-[#999999]" />
                <li>
                  <Link to="/ForgotPassword">비밀번호 찾기</Link>
                </li>
                <li className="w-[1px] h-2 bg-[#999999]" />
                <li>
                  <Link to="/Register">회원가입</Link>
                </li>
              </ul>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default Login;
